export const SITE = "https://zoremcommodities.com";

export const setPageMeta = ({ title, description, path, type = "website" }) => {
  if (title) document.title = title;
  const tags = {
    description,
    "og:title": title,
    "og:description": description,
    "og:url": path ? `${SITE}${path}` : undefined,
    "og:type": type,
    "twitter:title": title,
    "twitter:description": description,
  };
  Object.entries(tags).forEach(([k, v]) => {
    if (!v) return;
    const attr = k.startsWith("og:") ? "property" : "name";
    let el = document.head.querySelector(`meta[${attr}="${k}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, k);
      document.head.appendChild(el);
    }
    el.setAttribute("content", v);
  });
};

export const injectJsonLd = (id, data) => {
  document.getElementById(id)?.remove();
  const el = document.createElement("script");
  el.type = "application/ld+json";
  el.id = id;
  el.text = JSON.stringify(data);
  document.head.appendChild(el);
};
